module.exports = __webpack_public_path__ + "static/media/osaka.50ee6882.jpg";